var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-filtered-select',{attrs:{"selected-key":_vm.selectedCountry ? _vm.selectedCountry.value : null,"options":_vm.countryOptions,"invalid":_vm.invalid,"placeholder":"Country"},on:{"updateDropdownValue":_vm.onUpdateValue,"close":function($event){return _vm.$emit('close')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }